<p-progressBar *ngIf="show" mode="indeterminate" [style]="{'height': '5px','position':'fixed','width':'100%','z-index':'1001'}"></p-progressBar>